import CreateOrder from "components/OrderManage/CreateOrders";
import NotFooterLayout from "layouts/NotFooterLayout";

function CreateOrderPage() {
  return (
    <>   
      <NotFooterLayout namePage="สร้างคำสั่งซื้อสินค้า" >
        <div className="layout-content">
            <CreateOrder/> 
        </div>
      </NotFooterLayout>
    </>
  );
}

export default CreateOrderPage;
